<script>
    import { onMount, onDestroy } from 'svelte';

    export let params = {};

    onMount(() => {
        //window.scrollTo(0, 0);

        try {
            if (params && params.setState instanceof Function) {
                params.setState({
                    pageTitle: '',
                    pageTitleTag: '',
                });
            }
        } catch (err) {
            console.error(err);
        }
    });

    onDestroy(() => {

    });

</script>

<div class="canvas__col">
    <section class="auth-block tail">
        <h2 class="auth-block__title tail__title">Регистрация</h2>
        <p class="auth-block__text tail__text">Введите логин и пароль, которые вы хотите использовать для регистрации на Инсташпионе</p>
        <div class="auth-block__form-wrapper form">
            <input type="email" class="general-input auth-block__input" placeholder="Введите e-mail" />
            <input type="password" class="general-input auth-block__input" placeholder="Придумайте пароль" />
            <button class="button button_shadow auth-block__btn">зарегистрироваться</button>
            <p class="auth-block__form-error tail__error">Текст ошибки отображается здесь</p>
        </div>
        <p class="auth-block__text tail__text">или зарегистрируйтесь с помощью аккаунта:</p>
        <div class="auth-block__social-wrapper">
            <div class="auth-block__social-item">
                <img role="button" title="VKontakte" src="/spy20-lk/icons/auth-page/auth-social/auth-icon_vk.svg" alt="VK" class="auth-block__social-icon" />
            </div>
            <div class="auth-block__social-item">
                <img role="button" title="Google" src="/spy20-lk/icons/auth-page/auth-social/auth-icon_google.svg" alt="Google" class="auth-block__social-icon" />
            </div>
            <div class="auth-block__social-item">
                <img role="button" title="Mail.ru" src="/spy20-lk/icons/auth-page/auth-social/auth-icon_mailru.svg" alt="Mail.ru" class="auth-block__social-icon" />
            </div>
            <div class="auth-block__social-item">
                <img role="button" title="Одноклассники" src="/spy20-lk/icons/auth-page/auth-social/auth-icon_odnoklassniki.svg" alt="OK" class="auth-block__social-icon" />
            </div>
        </div>
    </section>

    <section class="auth-register-block">
        <h3 class="auth-register-block__title">Уже есть аккаунт?</h3>
        <a href="https://auth.zengram.ru/site/signup?language=ru-RU&url=https://instashpion.ru/auth/login&backUrl=https://instashpion.ru&redirectUrl=/instashpion/dashboard&theme=spy&service=spy&type=iframe&is_new_login=1" class="button button_ghost auth-register-block__btn">Авторизуйтесь</a>
    </section>
</div>

<style>

</style>